export enum ArticleCategoryType {
	DISH = 'dish',
	BEVERAGE = 'beverage',
	OTHER = 'other',
}
